import * as uuid4 from 'uuid/v4';

import * as SubToasterActions from '../../actions/subToaster';

import ReduxAction from '../../../../interfaces/ReduxAction';

const messageDuration = 7000;

export default function subToasterContentAndType (content: string, type: string): ReduxAction {
  return (dispatch): void => {
    const id = uuid4();

    dispatch(
      SubToasterActions.changeToasterMessage(
        content, type, id
      )
    );

    setTimeout(() => {
      dispatch(SubToasterActions.removeToasterMessage(id));
    }, messageDuration);
  };
}
